export default __webpack_public_path__ + "static/media/subcategory_car_7.728efef0.png";